var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 13.875C29.25 14.25 28.5 14.375 27.625 14.5C28.5 14 29.125 13.25 29.375 12.25C28.625 12.75 27.75 13 26.75 13.25C26 12.5 24.875 12 23.75 12C21.125 12 19.125 14.5 19.75 17C16.375 16.875 13.375 15.25 11.25 12.75C10.125 14.625 10.75 17 12.5 18.25C11.875 18.25 11.25 18 10.625 17.75C10.625 19.625 12 21.375 13.875 21.875C13.25 22 12.625 22.125 12 22C12.5 23.625 14 24.875 15.875 24.875C14.375 26 12.125 26.625 10 26.375C11.875 27.5 14 28.25 16.25 28.25C23.875 28.25 28.125 21.875 27.875 16C28.75 15.5 29.5 14.75 30 13.875Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.451e8436bbd152d21d38614d621af204.svg";
export { ForwardRef as ReactComponent };